export default __webpack_public_path__ + "static/mosaic-cursor-dont-dark-7b531cda05482803b136d73ec75b7a0a.png";